export default __webpack_public_path__ + "static/scores@mob_2x-9047c132128602c50269354274b7cd98.png";